import React from "react"
import {
  Alert,
  AlertIcon,
  AlertDescription,
  Link as ChakraLink
} from "@chakra-ui/react"
import { NavLink } from "react-router-dom"
import { Trans, useTranslation } from "react-i18next"

const SetPasswordAlert = ({ onLinkClick }: {
  onLinkClick?(): void
}): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Alert status="info" mb="1em">
      <AlertIcon />
      <AlertDescription>
        <Trans
          t={t}
          i18nKey="set_password_to_use_feature_prompt"
        >
          You must set a password before you can use this feature.
          Please do so on the <ChakraLink as={NavLink} onClick={onLinkClick} textDecoration="underline" to="/profile">profile page</ChakraLink>
          .
        </Trans>
      </AlertDescription>
    </Alert>
)}

export default SetPasswordAlert
